import { render, staticRenderFns } from "./MenuAppointmentItem.vue?vue&type=template&id=e6903662&"
import script from "./MenuAppointmentItem.vue?vue&type=script&lang=js&"
export * from "./MenuAppointmentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports